export default __webpack_public_path__ + "static/media/404-page.bd2422d4.png";